import {AggregationType, KpiOption} from '@hconnect/common/types'
import {TFunction} from 'i18next'

import {KpiAggregationTypeOption, KpiWeight, KpiUnitOption} from '../types'

export const weightKpiValidator =
  (t: TFunction, aggregationType: KpiAggregationTypeOption | null) =>
  (
    // Note: RHF validates type for a union field and expects the validator to accept the whole union, not just KpiWeight | null.
    value:
      | string
      | boolean
      | KpiOption
      | KpiUnitOption
      | KpiAggregationTypeOption
      | KpiWeight
      | null
      | undefined
  ) => {
    const isWeightAverage = aggregationType?.id === AggregationType.WeightAverage

    // Only validate if value is KpiWeight or null
    if (isWeightAverage && (!value || (typeof value === 'object' && 'id' in value && !value.id))) {
      return t('error.required')
    }

    return true
  }
